import pensiuneaAronAproape from "./images/pensiunea-aron-aproape.png";
import pensiuneaAronBalcon from "./images/pensiunea-aron-balcon.png";
import pensiuneaAronCaine from "./images/pensiunea-aron-caine.png";
import pensiuneaAronCamera2 from "./images/pensiunea-aron-camera-2.png";
import pensiuneaAronCamera3 from "./images/pensiunea-aron-camera-3.png";
import pensiuneaAronCamera4 from "./images/pensiunea-aron-camera-4.png";
import pensiuneaAronCameraCanapea from "./images/pensiunea-aron-camera-canapea.png";
import pensiuneaAronCapiteFan from "./images/pensiunea-aron-capite-fan.png";
import pensiuneaAronExterior2 from "./images/pensiunea-aron-exterior2.png";
import pensiuneaAronFata from "./images/pensiunea-aron-fata.png";
import pensiuneaAronFoisorInterior from "./images/pensiunea-aron-foisor-interior.png";
import pensiuneaAronFoisor from "./images/pensiunea-aron-foisor.png";
import pensiuneaAronInteriorSala2 from "./images/pensiunea-aron-interior-sala-2.png";
import pensiuneaAronInteriorSala from "./images/pensiunea-aron-interior-sala.png";
import pensiuneaAronPrivelisteBalcon from "./images/pensiunea-aron-priveliste-balcon.png";
import pensiuneaAronPrivelisteAnsamblu from "./images/pensiunea-aron-privire-ansamblu.png";
import pensiuneaAronSalaMese2 from "./images/pensiunea-aron-sala-mese-2.png";
import pensiuneaAronSalaMese3 from "./images/pensiunea-aron-sala-mese-3.png";
import pensiuneaAronSalaMese4 from "./images/pensiunea-aron-sala-mese-4.png";
import pensiuneaAronSalaMese5 from "./images/pensiunea-aron-sala-mese-5.png";
import pensiuneaAronSalaMese from "./images/pensiunea-aron-sala-mese.png";

export const navigation = [
  {
    id: 1,
    name: "Despre",
    url: "#despre",
  },
  {
    id: 2,
    name: "Facilitati",
    url: "#facilitati",
  },
  {
    id: 3,
    name: "Galerie",
    url: "#galerie",
  },
  {
    id: 4,
    name: "Tur Virtual",
    url: "#tur",
  },
  {
    id: 5,
    name: "Contact",
    url: "#contact",
  },
];

export const images = [
  {
    id: 1,
    url: pensiuneaAronAproape,
  },
  {
    id: 2,
    url: pensiuneaAronBalcon,
  },
  {
    id: 3,
    url: pensiuneaAronCaine,
  },
  {
    id: 4,
    url: pensiuneaAronCamera2,
  },
  {
    id: 5,
    url: pensiuneaAronCamera3,
  },
  {
    id: 6,
    url: pensiuneaAronCamera4,
  },
  {
    id: 7,
    url: pensiuneaAronCameraCanapea,
  },
  {
    id: 8,
    url: pensiuneaAronCapiteFan,
  },
  {
    id: 9,
    url: pensiuneaAronExterior2,
  },
  {
    id: 10,
    url: pensiuneaAronFata,
  },
  {
    id: 11,
    url: pensiuneaAronFoisorInterior,
  },
  {
    id: 12,
    url: pensiuneaAronFoisor,
  },
  {
    id: 13,
    url: pensiuneaAronInteriorSala2,
  },
  {
    id: 14,
    url: pensiuneaAronInteriorSala,
  },
  {
    id: 15,
    url: pensiuneaAronPrivelisteBalcon,
  },
  {
    id: 16,
    url: pensiuneaAronPrivelisteAnsamblu,
  },
  {
    id: 17,
    url: pensiuneaAronSalaMese2,
  },
  {
    id: 18,
    url: pensiuneaAronSalaMese3,
  },
  {
    id: 19,
    url: pensiuneaAronSalaMese4,
  },
  {
    id: 20,
    url: pensiuneaAronSalaMese5,
  },
  {
    id: 21,
    url: pensiuneaAronSalaMese,
  },
];
